// extracted by mini-css-extract-plugin
export default {"text":"Paragraph_text__NmCnA","margin":"Paragraph_margin__abU5l","margin_top":"Paragraph_margin_top__cdmmN","warning":"Paragraph_warning__U7VUc"};